/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Label, Row } from "reactstrap";
import Select from "react-select";
import { Button, Table } from "react-bootstrap";
import { Portion } from "../../../../redux/setMenuSlice";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import {
  useLazyGetMenuTypesQuery,
  useLazyGetPortionSizesQuery,
  useLazyGetDimensionsQuery,
} from "../../../../redux/services/CustomTypeService";
import MenuItemImageUpdate, {
  UpdateImageDetails,
} from "../../../../components/MenuItemImageUpdate/MenuItemImageUpdate";
import {
  useGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetAllOrganizationsQuery,
  useLazyGetRestaurantFilterTagsQuery,
  useUpdateMenuItemImagesMutation,
  useUpdateMenuItemMutation,
} from "../../../../redux/services/menuItemService";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import ControlledUpdateSelect from "../../../../components/ContolledUpdateselect";
import { DELIVERY_TIME } from "../../../../dummyData/dummyData";
import ControlledSelect from "../../../../components/ControlledSelect";
import ControlledRowSelectPortion from "../../../../components/ControlledRowSelectPortion";
import ControlledRowTextFieldForPortion from "../../../../components/RowTextFieldsForPortions";
import ButtonComponent from "../../../../components/ButtonComponent";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import { toast } from "react-toastify";
import {
  capitalizeFirstLetterEdit,
  extractImageFilename,
} from "../../../../utility/Utility";
import "./index.css";

interface CategoryOption {
  value: string;
  label: string;
}

interface MenuItemUpdate {
  menuItemId?: string;
  category: string;
  description: string;
  displayName: string;
  abbreviation?: string;
  imageUrl: string[];
  mealType: string;
  preparingTime: number;
  price: number;
  restaurantId: string;
  isCustomMenuItem?: boolean;
  customMenuItemSection?: string;
  supportsPreOrdering?: boolean;
  supportPortionSizes?: boolean;
  portions?: Portion[];
  allergenInformation?: string[];
  foodAttributes?: string[];
  portionSize: string;
  portionPrice: 0;
  productId?: string;
  filterTags?: Array<{ value: string; label: React.ReactNode }>;
  isCooporateProduct?: boolean;
  organizationIds?: Array<{ value: string; label: string }>;
  dimensions?: { [dimensionId: string]: { dimensionValueId: string } };
  tinyId?: number;
  isSellingProduct?: boolean;
  skuId?: string;
}

const UpdateItem = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const menuItem = state?.menuItem;
  const reastaurantData = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails
  );

  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [updateButtonLoading, setUpdateButtonLoading] = useState(false);
  const [imageUpdateLoading, setImageUpdateLoading] = useState(false);
  const [imageOrder, setImageOrder] = useState<string[]>(
    menuItem?.imageUrl || []
  );
  const originalImageDetails = useMemo(
    () =>
      menuItem?.imageUrl?.map((url: string) => ({
        oldImgUrl: extractImageFilename(url, RestID),
        newImgRef: extractImageFilename(url, RestID),
      })) || [],
    [menuItem?.imageUrl, RestID]
  );

  const [updatedImagesDetails, setUpdatedImagesDetails] =
    useState<UpdateImageDetails[]>(originalImageDetails);
  const [deletedImages, setDeletedImages] = useState<string[]>([]);
  const [imageChanged, setImageChanged] = useState<boolean>(false);

  // Corporate Support States
  const [isCooporateProduct, setisCooporateProduct] = useState(
    menuItem?.isCooporateProduct || false
  );
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [organizationOptions, setOrganizationOptions] = useState<any[]>([]);
  const [hasOrganizationsLoaded, setHasOrganizationsLoaded] = useState(false);

  const hasChanges = useMemo(() => {
    if (imageChanged) return true;
    if (deletedImages.length > 0) return true;
    const origMap = new Map(
      originalImageDetails.map((d: any) => [d.oldImgUrl, d.newImgRef])
    );
    const updMap = new Map(
      updatedImagesDetails.map((d) => [d.oldImgUrl, d.newImgRef])
    );

    if (origMap.size !== updMap.size) return true;

    for (const [k, v] of origMap) {
      if (updMap.get(k as any) !== v) return true;
    }

    const origOrder = menuItem?.imageUrl || [];
    if (imageOrder.join("|") !== origOrder.join("|")) return true;

    return false;
  }, [
    imageChanged,
    deletedImages,
    originalImageDetails,
    updatedImagesDetails,
    imageOrder,
    menuItem?.imageUrl,
  ]);

  const [canPortion, setCanPortion] = useState(
    menuItem?.supportPortionSizes || false
  );
  const [editMode, setEditMode] = useState(false);
  const [portionSize, setPortionSize] = useState("");
  const [portionPrice, setPortionPrice] = useState("");
  const [portionErrorMessage, setPortionErrorMessage] = useState<string | null>(
    null
  );
  const [portions, setPortions] = useState<
    { displayName: string; additionalCost: number }[]
  >(
    menuItem?.portions?.map((portion: any) => ({
      displayName: portion.displayName || portion.size,
      additionalCost: portion.additionalCost,
    })) || []
  );
  const [canCustomize, setCanCustomize] = useState(
    menuItem?.isCustomMenuItem || false
  );
  const [isCanSellProduct, setIsCanSellProduct] = useState(
    menuItem?.isSellingProduct !== undefined 
      ? menuItem.isSellingProduct 
      : (menuItem?.productId || menuItem?.price ? true : false)
  );

  const [selectedOption, setSelectedOption] = useState(
    menuItem?.customMenuItemSection
      ? {
          label: menuItem.customMenuItemSection,
          value: menuItem.customMenuItemSection,
        }
      : null
  );
  const [selectedcustomMenuItemTypeId, setSelectedcustomMenuItemTypeId] =
    useState<string | null>(null);
  const [selectedDimensionValues, setSelectedDimensionValues] = useState<{
    [dimensionId: string]: any;
  }>({});

  const [updateMenuItem] = useUpdateMenuItemMutation();
  const [updateMenuItemImages] = useUpdateMenuItemImagesMutation();
  const [
    getAllOrganizations,
    { data: organizationsData, isLoading: isOrganizationsLoading },
  ] = useLazyGetAllOrganizationsQuery();
  const [isPortionPriceDisable, setIsPortionPriceDisable] =
    useState<boolean>(false);

  // Initialize the form with validation rules
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    trigger, // Add trigger to manually validate fields
  } = useForm<MenuItemUpdate>({
    defaultValues: {
      menuItemId: menuItem?.id || "",
      category: menuItem?.category || "",
      description: menuItem?.description || "",
      displayName: menuItem?.displayName || "",
      abbreviation: menuItem?.abbreviation || "",
      imageUrl: menuItem?.imageUrl || [],
      mealType: menuItem?.mealType || "breakfast",
      preparingTime: menuItem?.preparingTime || 0,
      price: menuItem?.price || 0,
      restaurantId:
        menuItem?.restaurantId ||
        localStorage.getItem("selectedRestaurantId") ||
        "",
      skuId: menuItem?.skuId || "",
      productId: menuItem?.productId || "",
      isCustomMenuItem: menuItem?.isCustomMenuItem || false,
      customMenuItemSection: menuItem?.customMenuItemSection || "",
      supportsPreOrdering: menuItem?.supportsPreOrdering || false,
      supportPortionSizes: menuItem?.supportPortionSizes || false,
      portions:
        menuItem?.portions?.map((portion: any) => ({
          displayName: portion.displayName || portion.size,
          additionalCost: portion.additionalCost,
        })) || [],
      allergenInformation:
        menuItem?.allergenInformation?.map((allergen: string) => ({
          value: allergen,
          label: allergen,
          logoUrl: getImageUrl(allergen),
        })) || [],
      foodAttributes:
        menuItem?.foodAttributes?.map((attr: string) => ({
          value: attr,
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(attr)}
                alt={attr}
                width="20px"
                height="20px"
              />
              {attr}
            </div>
          ),
        })) || [],
      filterTags: menuItem?.tags
        ? Object.entries(menuItem.tags as Record<string, string[]>).flatMap(
            ([category, tags]) =>
              tags.map((tag: string) => ({
                value: capitalizeFirstLetterEdit(tag),
                label: (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "left",
                      gap: "2%",
                    }}
                  >
                    {capitalizeFirstLetterEdit(tag)}
                  </div>
                ),
              }))
          )
        : [],
      isCooporateProduct: menuItem?.isCooporateProduct || false,
      organizationIds: [],
      tinyId: menuItem?.tinyId || 0,
      isSellingProduct: menuItem?.isSellingProduct !== undefined 
        ? menuItem.isSellingProduct 
        : (menuItem?.productId || menuItem?.price ? true : false),
    },
  });

  // Watch for corporate product changes to trigger validation
  const watchIsCooporateProduct = watch("isCooporateProduct");
  const watchOrganizationIds = watch("organizationIds");

  // Custom validation function for organizations
  const validateOrganizations = (value: any) => {
    if (watchIsCooporateProduct && (!value || value.length === 0)) {
      return "At least one organization is required when corporate support is enabled";
    }
    return true;
  };

  // Load organizations when component mounts if menuItem has organizationIds
  useEffect(() => {
    if (menuItem?.organizationIds?.length && !hasOrganizationsLoaded) {
      getAllOrganizations();
    }
  }, [menuItem?.organizationIds, hasOrganizationsLoaded, getAllOrganizations]);

  // Load organizations when corporate support is enabled and in edit mode
  useEffect(() => {
    if (isCooporateProduct && editMode && !hasOrganizationsLoaded) {
      getAllOrganizations();
    }
  }, [
    isCooporateProduct,
    editMode,
    hasOrganizationsLoaded,
    getAllOrganizations,
  ]);

  // Filter organizations based on search input and map organization IDs to display names
  useEffect(() => {
    if (organizationsData) {
      setHasOrganizationsLoaded(true);

      let allOptions = organizationsData.map((org) => ({
        value: org.organizationId,
        label: `${org.displayName} (${org.code})`,
      }));

      // Filter based on search input if provided
      if (organizationSearch) {
        allOptions = allOptions.filter((org) =>
          org.label.toLowerCase().includes(organizationSearch.toLowerCase())
        );
      }

      setOrganizationOptions(allOptions);

      // If we have organization IDs from the menuItem, map them to display names
      if (menuItem?.organizationIds?.length) {
        const currentOrgs = watch("organizationIds") || [];

        // Only update if we haven't already mapped the organizations
        if (
          currentOrgs.length === 0 ||
          currentOrgs.some(
            (org) => typeof org.label === "string" && !org.label.includes("(")
          )
        ) {
          const mappedOrganizations = menuItem.organizationIds
            .map((orgId: string) => {
              const orgData = organizationsData.find(
                (o) => o.organizationId === orgId
              );
              return orgData
                ? {
                    value: orgData.organizationId,
                    label: `${orgData.displayName} (${orgData.code})`,
                  }
                : null;
            })
            .filter(Boolean); // Remove any null values

          if (mappedOrganizations.length > 0) {
            setValue("organizationIds", mappedOrganizations);
          }
        }
      }
    }
  }, [
    organizationsData,
    organizationSearch,
    menuItem?.organizationIds,
    watch,
    setValue,
  ]);

  // Trigger organizations validation when corporate support or organizations change
  useEffect(() => {
    if (editMode) {
      trigger("organizationIds");
    }
  }, [watchIsCooporateProduct, watchOrganizationIds, trigger, editMode]);

  // Lazy query to fetch portion sizes based on restaurant ID
  const [triggerGetPortionSizes, { data: portionSizesData = [] }] =
    useLazyGetPortionSizesQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetPortionSizes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetPortionSizes]);

  const portionSizesOptions = portionSizesData.map((size) => ({
    value: size.portionSize,
    label: size.portionSize,
  }));

  useEffect(() => {
    if (menuItem) {
      setPortions(
        menuItem?.portions?.map((portion: any) => ({
          displayName: portion.displayName || portion.size,
          additionalCost: portion.additionalCost,
        })) || []
      );
      setCanPortion(menuItem?.supportPortionSizes || false);
      setCanCustomize(menuItem?.isCustomMenuItem || false);
      setisCooporateProduct(menuItem?.isCooporateProduct || false);
    }
  }, [menuItem]);

  // Lazy query to fetch menu types based on restaurant ID
  const [
    triggerGetMenuTypes,
    { data: menuTypes = [], isLoading: isMenuTypesLoading },
  ] = useLazyGetMenuTypesQuery();

  // Fetch dimensions for selected custom menu type
  const [
    triggerGetDimensions,
    { data: dimensionsData = [], isLoading: isDimensionsLoading },
  ] = useLazyGetDimensionsQuery();

  const [
    triggerGetFilterTags,
    { data: filterTagsData, isLoading: isFilterTagsLoading },
  ] = useLazyGetRestaurantFilterTagsQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetFilterTags(RestID);
    }
  }, [RestID, triggerGetFilterTags]);

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    Object.entries(filterTagsData.filterTags).forEach(
      ([category, categoryData]) => {
        if (categoryData.tags && Array.isArray(categoryData.tags)) {
          categoryData.tags.forEach((tag) => {
            if (tag.show) {
              options.push({ value: tag.tag, label: `${tag.tag}` });
            }
          });
        }
      }
    );

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  useEffect(() => {
    if (RestID) {
      triggerGetMenuTypes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetMenuTypes]);

  // Fetch dimensions when custom menu type is selected
  useEffect(() => {
    if (RestID && selectedcustomMenuItemTypeId) {
      triggerGetDimensions({
        restaurantId: RestID,
        customMenuItemTypeId: selectedcustomMenuItemTypeId,
      });
    }
  }, [RestID, selectedcustomMenuItemTypeId, triggerGetDimensions]);

  // Initialize selectedcustomMenuItemTypeId from menuItem data
  useEffect(() => {
    if (menuItem?.customMenuItemSection && menuTypes.length > 0) {
      const selectedMenuType = menuTypes.find(
        (type) => type.name === menuItem.customMenuItemSection
      );
      if (selectedMenuType) {
        setSelectedcustomMenuItemTypeId(selectedMenuType.id);
      }
    }
  }, [menuItem?.customMenuItemSection, menuTypes]);

  // Initialize dimension values from menuItem data
  useEffect(() => {
    if (menuItem?.dimensions && Object.keys(menuItem.dimensions).length > 0) {
      const initialDimensionValues: { [dimensionId: string]: any } = {};
      Object.entries(menuItem.dimensions).forEach(
        ([dimensionId, dimensionData]: [string, any]) => {
          if (dimensionData.dimensionValueId) {
            // We'll need to find the actual dimension value object when dimensions data loads
            initialDimensionValues[dimensionId] = {
              value: dimensionData.dimensionValueId,
            };
          }
        }
      );
      setSelectedDimensionValues(initialDimensionValues);
    }
  }, [menuItem?.dimensions]);

  // Update dimension values with full objects when dimensions data loads
  useEffect(() => {
    if (
      dimensionsData.length > 0 &&
      Object.keys(selectedDimensionValues).length > 0
    ) {
      const updatedDimensionValues: { [dimensionId: string]: any } = {};
      Object.entries(selectedDimensionValues).forEach(
        ([dimensionId, currentValue]) => {
          const dimension = dimensionsData.find((d) => d.id === dimensionId);
          if (dimension && dimension.dimensionValue && currentValue.value) {
            const dimensionValue = dimension.dimensionValue.find(
              (dv: any) => dv.id === currentValue.value
            );
            if (dimensionValue) {
              updatedDimensionValues[dimensionId] = {
                value: dimensionValue.id,
                label: dimensionValue.displayName,
              };
            }
          }
        }
      );
      if (Object.keys(updatedDimensionValues).length > 0) {
        setSelectedDimensionValues(updatedDimensionValues);
      }
    }
  }, [dimensionsData, selectedDimensionValues]);

  function capitalizeFirstLetter(string: string): string {
    if (!string) return string;
    return string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const menuCategories: CategoryOption[] = reastaurantData?.categoryTags.map(
    (value: string) => {
      return {
        value: capitalizeFirstLetter(value),
        label: capitalizeFirstLetter(value),
      };
    }
  ) || [{ value: "", label: "" }];

  const handleEditButtonClick = () => {
    setEditMode(!editMode);
    // Load organizations when entering edit mode if needed
    if (
      !editMode &&
      (isCooporateProduct || menuItem?.organizationIds?.length) &&
      !hasOrganizationsLoaded
    ) {
      getAllOrganizations();
    }
  };

  const { data: allergenData } = useGetAllergenInformationQuery();

  const allergenOptions = useMemo(
    () =>
      allergenData?.allergenInformation.map((allergen) => ({
        value: allergen.displayName,
        label: allergen.displayName,
        logoUrl: getImageUrl(allergen.displayName),
      })) || [],
    [allergenData]
  );

  const getOptionLabel = (option: any) => (
    <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
      <img src={option.logoUrl} alt={option.value} width="20px" height="20px" />
      {option.label}
    </div>
  );

  const { data: foodAttributesData } = useGetFoodAttributesListQuery();

  const foodAttributesOptions =
    foodAttributesData?.FoodAttributesList.map((attr) => ({
      value: attr.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(attr.displayName)}
            alt={attr.displayName}
            width="20px"
            height="20px"
          />
          {attr.displayName}
        </div>
      ),
    })) || [];

  const imageUpdateCallbackHandler = useCallback((e: UpdateImageDetails) => {
    if (e.newImgRef === undefined) {
      setDeletedImages((prev) =>
        prev.includes(e.oldImgUrl) ? prev : [e.oldImgUrl, ...prev]
      );
      setUpdatedImagesDetails((prev) =>
        prev.filter((it) => it.oldImgUrl !== e.oldImgUrl)
      );
      setImageChanged(true);
      return;
    }

    setUpdatedImagesDetails((prev) => {
      if (!e.oldImgUrl || e.oldImgUrl === "") {
        return [...prev, e];
      }
      const existingIndex = prev.findIndex(
        (item) => item.oldImgUrl === e.oldImgUrl
      );
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = e;
        return updated;
      } else {
        return [...prev, e];
      }
    });
    setImageChanged(true);
  }, []);

  const handleSaveImages = () => {
    setImageUpdateLoading(true);
    handleImageUpdate({
      menuItemId: menuItem?.id || "",
      restaurantId: RestID,
      newImages: updatedImagesDetails,
    });
  };

  const handleImageUpdate = async (data: {
    menuItemId: string;
    restaurantId: string;
    newImages: UpdateImageDetails[] | any[];
  }) => {
    try {
      const payloadImages = [
        ...updatedImagesDetails,
        ...deletedImages.map((old) => ({ oldImgUrl: old })),
      ];

      await updateMenuItemImages({
        ...data,
        newImages: payloadImages,
      }).unwrap();
      toast.success("Images updated successfully");
      setImageUpdateLoading(false);
      setImageChanged(false);
      setDeletedImages([]);
      navigate("/productCatalogue/stock-keeping-unit");
    } catch (error) {
      console.error("Failed to update images:", error);
      toast.error("Failed to update images");
      setImageUpdateLoading(false);
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCanCustomize(event.target.checked);
    setValue("isCustomMenuItem", event.target.checked);
    if (!event.target.checked) {
      setSelectedOption(null);
      setValue("customMenuItemSection", "");
      setSelectedcustomMenuItemTypeId(null);
      setSelectedDimensionValues({});
    }
  };

  const handleCorporateSupportChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    setisCooporateProduct(isChecked);
    setValue("isCooporateProduct", isChecked);
    if (!isChecked) {
      setValue("organizationIds", []);
    } else if (!hasOrganizationsLoaded) {
      // Load organizations when enabling corporate support
      getAllOrganizations();
    }
    // Trigger validation immediately when checkbox changes
    if (editMode) {
      trigger("organizationIds");
    }
  };

  const handleCanSellChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    setIsCanSellProduct(isChecked);
    setValue("isSellingProduct", isChecked);
  };

  const handleOrganizationSearch = (inputValue: string) => {
    setOrganizationSearch(inputValue);
  };

  const handleSelectChange = (option: any) => {
    setSelectedOption(option);
    setValue("customMenuItemSection", option ? option.value : "");

    // Find the selected menu type ID and store it
    if (option) {
      const selectedMenuType = menuTypes.find(
        (type) => type.name === option.value
      );
      if (selectedMenuType) {
        setSelectedcustomMenuItemTypeId(selectedMenuType.id);
      }
    } else {
      setSelectedcustomMenuItemTypeId(null);
      setSelectedDimensionValues({});
    }
  };

  const handleCheckboxChangeForPortion = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCanPortion(event.target.checked);
  };

  const addPortion = () => {
    if (!portionSize) {
      setPortionErrorMessage("Please select a portion size.");
      return;
    }

    const portionExists = portions.some(
      (portion) => portion.displayName === portionSize
    );

    if (portionExists) {
      setPortionErrorMessage("Portion size is already added.");
    } else {
      const selectedPortion = portionSizesData.find(
        (size) => size.portionSize === portionSize
      );

      const portionSizeCost =
        selectedPortion &&
        selectedPortion.portionSize === portionSizesData[0]?.portionSize
          ? 0
          : Number(portionPrice);

      setPortions([
        ...portions,
        { displayName: portionSize, additionalCost: portionSizeCost },
      ]);

      setPortionSize("");
      setPortionPrice("");
      setValue("portionSize", "");
      setValue("portionPrice", 0);
      setPortionErrorMessage(null);
    }
  };

  const deletePortion = (index: number) => {
    const updatedPortions = portions.filter((_, i) => i !== index);
    setPortions(updatedPortions);
    setValue("portions", updatedPortions);
    setPortionErrorMessage(null);
  };

  const customMenuOptions = menuTypes.map((type) => ({
    label: type.name,
    value: type.name,
  }));

  const handleSelectPortion = (option: any) => {
    setPortionSize(option.value);

    if (option.value === portionSizesData[0].portionSize) {
      setValue("portionPrice", 0);
      setIsPortionPriceDisable(true);
    } else {
      setIsPortionPriceDisable(false);
    }
  };

  const isPortionButtonDisabled = !portionSize || !portionPrice;

  const handleDimensionValueChange = (
    dimensionId: string,
    selectedValue: any
  ) => {
    setSelectedDimensionValues((prev) => ({
      ...prev,
      [dimensionId]: selectedValue,
    }));
  };

  const handleUpdate = async (data: MenuItemUpdate) => {
    // Validate form before submission
    const isValid = await trigger();
    if (!isValid) {
      toast.error("Please fix the validation errors before submitting");
      return;
    }

    setUpdateButtonLoading(true);
    setIsLoading(true);

    const structuredTags: { [key: string]: string[] } = {};

    if (filterTagsData?.filterTags && data.filterTags) {
      const currentSelectedTagValues = (data.filterTags ?? []).map((tag) =>
        tag.value.toLowerCase()
      );

      Object.entries(filterTagsData.filterTags).forEach(
        ([categoryKey, categoryData]) => {
          const category = categoryKey.toLowerCase();
          const categoryTagValues = (categoryData.tags || []).map((tag) =>
            tag.tag.toLowerCase()
          );

          const selectedTagsInCategory = currentSelectedTagValues.filter(
            (tag) => categoryTagValues.includes(tag)
          );

          if (selectedTagsInCategory.length > 0) {
            structuredTags[category] = selectedTagsInCategory;
          }
        }
      );
    }

    // Validate required dimensions
    if (
      canCustomize &&
      selectedcustomMenuItemTypeId &&
      dimensionsData.length > 0
    ) {
      for (const dimension of dimensionsData) {
        if (dimension.isRequired && !selectedDimensionValues[dimension.id]) {
          toast.error(`${dimension.displayName} is required`);
          setUpdateButtonLoading(false);
          setIsLoading(false);
          return;
        }
      }
    }

    // Extract organization IDs from selected organizations
    const selectedOrganizationIds = data.organizationIds
      ? data.organizationIds.map((org: any) => org.value)
      : [];

    // Extract selected dimension values and transform to required format
    const dimensionSelections =
      canCustomize &&
      selectedcustomMenuItemTypeId &&
      Object.keys(selectedDimensionValues).length > 0
        ? Object.entries(selectedDimensionValues).reduce(
            (acc, [dimensionId, selectedValue]) => {
              if (selectedValue?.value) {
                acc[dimensionId] = {
                  dimensionValueId: selectedValue.value,
                };
              }
              return acc;
            },
            {} as { [dimensionId: string]: { dimensionValueId: string } }
          )
        : undefined;

    const updateData: any = {
      restaurantId: RestID,
      menuItemId: data.menuItemId,
      category: data.category,
      description: data.description,
      displayName: data.displayName,
      abbreviation: data.abbreviation,
      skuId: data.skuId,
      mealType: data.mealType,
      preparingTime: data.preparingTime,
      price: +data.price,
      isCustomMenuItem: data.isCustomMenuItem,
      customMenuItemSection: data.customMenuItemSection,
      customMenuItemTypeId: selectedcustomMenuItemTypeId,
      productId: data.productId,
      tags: structuredTags,
      supportsPreOrdering: data.supportsPreOrdering,
      supportPortionSizes: canPortion,
      portions: canPortion
        ? portions.map((portion) => ({
            displayName: portion.displayName || "",
            additionalCost: portion.additionalCost || 0,
          }))
        : [],
      allergenInformation: data?.allergenInformation?.map(
        (item: any) => item.value
      ),
      foodAttributes: data?.foodAttributes?.map((item: any) => item.value),
      isCooporateProduct: data.isCooporateProduct,
      organizationIds: selectedOrganizationIds,
      dimensions: dimensionSelections,
      tinyId: +(data.tinyId || 0),
      isSellingProduct: data.isSellingProduct,
    };

    try {
      const response = await updateMenuItem({ data: updateData }).unwrap();
      if (response === "OK") {
        toast.success("Product updated successfully");
        navigate("/productCatalogue/stock-keeping-unit");
      }
    } catch (error: any) {
      if (
        error.status === 409 &&
        error.data === "Product name already exists"
      ) {
        toast.error("Product name is already exists");
      }
      if (error.status === 409 && error.data === "ProductId Already exists") {
        toast.error("Product ID already exists");
      }
      toast.error("Failed to update Product");
    } finally {
      setUpdateButtonLoading(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardHeader
          className="d-flex justify-content-between align-items-center"
          style={{
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h4>Update Product</h4>
          <div>
            <Button
              variant="light"
              type="button"
              onClick={handleEditButtonClick}
            >
              <FontAwesomeIcon icon={faEdit} title="Edit" color="#699BF7" />
            </Button>
          </div>
        </CardHeader>
        <CardBody>
          {menuItem && (
            <MenuItemImageUpdate
              exsistImages={menuItem.imageUrl}
              uploadImageCallBack={imageUpdateCallbackHandler}
              onOrderChange={(refs) => {
                setImageOrder(refs);
                setImageChanged(true);
              }}
              isDisable={!editMode}
            />
          )}
          {editMode &&
            (imageUpdateLoading ? (
              <>
                <Button variant="warning" className="mt-3" disabled>
                  {" "}
                  <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  Save Changes
                </Button>
              </>
            ) : (
              <Button
                variant="warning"
                className="mt-3"
                onClick={handleSaveImages}
                disabled={!hasChanges}
              >
                Save Changes
              </Button>
            ))}
          <hr />
          <form>
            <ControlledRowTextField
              label={"Product Name"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter Product Name"}
              control={control}
              rules={{ required: "Product Name is required" }}
              isDisabled={!editMode}
              isRequired={true}
            />
            {errors.displayName && (
              <p className="text-danger mt-2">
                {errors.displayName.message as React.ReactNode}
              </p>
            )}
            <hr />
            <ControlledRowTextField
              label={"Abbreviation"}
              inputName={"abbreviation"}
              inputType={"text"}
              placeholder={"Enter Abbreviation"}
              control={control}
              isDisabled={!editMode}
            />
            <hr />
            {/* <ControlledUpdateSelect
              label={"Select Delivery Time"}
              inputName={"preparingTime"}
              control={control}
              isMulti={false}
              optionsList={DELIVERY_TIME}
              rules={{ required: "Delivery Time is required" }}
              isDisabled={!editMode}
              isRequired={true}
            />
            {errors.preparingTime && (
              <p className="text-danger mt-2">
                {errors.preparingTime.message as React.ReactNode}
              </p>
            )}
            <hr /> */}
            <ControlledRowTextField
              label={"SKU ID"}
              inputName={"skuId"}
              inputType={"text"}
              placeholder={"Enter SKU ID"}
              control={control}
              isDisabled={!editMode}
              isRequired={true}
              rules={{ required: "SKU ID is required" }}
            />
            {errors.skuId && (
              <p className="text-danger mt-2">
                {errors.skuId.message as React.ReactNode}
              </p>
            )}
            <hr />
            <ControlledRowTextField
              label={"Tiny ID"}
              inputName={"tinyId"}
              inputType={"number"}
              placeholder={"Enter Tiny ID"}
              control={control}
              isDisabled={!editMode}
              rules={{
                min: {
                  value: 0,
                  message: "Tiny ID must be 0 or greater",
                },
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Tiny ID must be a number",
                },
              }}
            />

            <hr />
            <ControlledUpdateSelect
              label={"Category *"}
              inputName={"category"}
              control={control}
              isMulti={false}
              optionsList={menuCategories}
              rules={{ required: "Category is required" }}
              isDisabled={!editMode}
              isRequired={true}
            />
            {errors.category && (
              <p className="text-danger mt-2">
                {errors.category.message as React.ReactNode}
              </p>
            )}
            <hr />
            <ControlledSelect
              label={"Allergic Infromation"}
              inputName={"allergenInformation"}
              control={control}
              isMulti={true}
              optionsList={allergenOptions}
              getOptionLabel={getOptionLabel}
              isDisabled={!editMode}
            />

            <hr />
            <ControlledSelect
              label={"Food Attributes"}
              inputName={"foodAttributes"}
              control={control}
              isMulti={true}
              optionsList={foodAttributesOptions}
              isDisabled={!editMode}
            />

            <hr />
            <ControlledSelect
              label={"Filter Tags"}
              inputName={"filterTags"}
              control={control}
              isMulti={true}
              optionsList={filterTagsOptions}
              isDisabled={!editMode}
            />

            <hr />

            <ControlledRowTextField
              label={"Description"}
              inputName={"description"}
              inputType={"textarea"}
              placeholder={"Enter Description"}
              control={control}
              rules={{ required: "Description is required" }}
              isDisabled={!editMode}
            />
            {errors.description && (
              <p className="text-danger mt-2">
                {errors.description.message as React.ReactNode}
              </p>
            )}

            <hr />

            {/* Can Sell Section */}
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="isCanSellProduct"
                >
                  Can Sell
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isCanSellProduct"
                  checked={isCanSellProduct}
                  onChange={handleCanSellChange}
                  disabled={!editMode}
                />
              </Col>
            </Row>

            {isCanSellProduct && (
              <>
                <hr />
                <ControlledRowTextField
                  label={"Product ID"}
                  inputName={"productId"}
                  inputType={"text"}
                  placeholder={"Enter Product ID"}
                  control={control}
                  isDisabled={!editMode}
                  isRequired={true}
                />
                <hr />
                <ControlledRowTextField
                  label={"Product Price (Rs.)"}
                  inputName={"price"}
                  inputType={"number"}
                  placeholder={"Enter Product Price"}
                  control={control}
                  rules={{
                    required: "Product Price is required",
                    // min: {
                    //   value: 0.01,
                    //   message: "Product Price must be greater than 0",
                    // },
                  }}
                  isDisabled={!editMode}
                  isRequired={true}
                />
                {errors.price && (
                  <p className="text-danger mt-2">
                    {errors.price.message as React.ReactNode}
                  </p>
                )}
                <hr />

                {/* Corporate Support Section */}
                <Row>
                  <Col lg="4">
                    <Label className="" htmlFor="isCooporateProduct">
                      Corporate Product
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isCooporateProduct"
                      checked={isCooporateProduct}
                      onChange={handleCorporateSupportChange}
                      disabled={!editMode}
                    />
                  </Col>
                </Row>

                {isCooporateProduct && (
                  <>
                    <hr />
                    <Row>
                      <Col lg="4">
                        <Label htmlFor="organizations">Organizations *</Label>
                      </Col>
                      <Col lg="8">
                        <ControlledSelect
                          label={""}
                          inputName={"organizationIds"}
                          control={control}
                          isMulti={true}
                          optionsList={organizationOptions}
                          placeholder="Search organizations..."
                          onInputChange={handleOrganizationSearch}
                          isLoading={isOrganizationsLoading}
                          isDisabled={!editMode}
                          rules={{ validate: validateOrganizations }}
                        />
                        {errors.organizationIds && (
                          <p className="text-danger mt-2">
                            {errors.organizationIds.message as React.ReactNode}
                          </p>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                <hr />

                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="supportsPreOrdering"
                    >
                      Supports Pre-Ordering
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="supportsPreOrdering"
                      checked={watch("supportsPreOrdering")}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setValue("supportsPreOrdering", event.target.checked);
                      }}
                      disabled={!editMode}
                    />
                  </Col>
                </Row>
              </>
            )}
            <hr />

            <Row>
              <Col lg="4">
                <Label className="form-check-label" htmlFor="canCustomize">
                  Can use for Customize
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="canCustomize"
                  checked={canCustomize}
                  onChange={handleCheckboxChange}
                  disabled={!editMode}
                />
              </Col>
            </Row>
            <hr />
            {canCustomize && (
              <>
                <Row>
                  <Col lg="4">
                    <Label htmlFor="customMenuItemSection">
                      Custom Menu Type
                    </Label>
                  </Col>
                  <Col lg="8">
                    <Select
                      value={selectedOption}
                      onChange={handleSelectChange}
                      options={customMenuOptions}
                      placeholder="Search Product"
                      isSearchable
                      isLoading={isMenuTypesLoading}
                      isDisabled={!editMode}
                    />
                    {errors.customMenuItemSection && (
                      <p className="text-danger mt-2">
                        {errors.customMenuItemSection.message}
                      </p>
                    )}
                  </Col>
                </Row>
                <hr />
                {/* Dimensions Section */}
                {selectedcustomMenuItemTypeId && (
                  <>
                    {isDimensionsLoading ? (
                      <div>
                        <Row className="mb-3">
                          <Col lg="4">
                            <div className="dimension-skeleton-label"></div>
                          </Col>
                          <Col lg="8">
                            <div className="dimension-skeleton-dropdown"></div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg="4">
                            <div className="dimension-skeleton-label"></div>
                          </Col>
                          <Col lg="8">
                            <div className="dimension-skeleton-dropdown"></div>
                          </Col>
                        </Row>
                      </div>
                    ) : dimensionsData && dimensionsData.length > 0 ? (
                      // Check if there are any dimensions with values
                      (() => {
                        const dimensionsWithValues = dimensionsData.filter(
                          (dimension) =>
                            dimension.dimensionValue &&
                            dimension.dimensionValue.length > 0
                        );

                        if (dimensionsWithValues.length > 0) {
                          return dimensionsWithValues.map((dimension) => (
                            <div key={dimension.id}>
                              <Row className="mb-3">
                                <Col lg="4">
                                  <Label htmlFor={`dimension-${dimension.id}`}>
                                    {dimension.displayName}
                                    {dimension.isRequired && (
                                      <span className="text-danger"> *</span>
                                    )}
                                  </Label>
                                </Col>
                                <Col lg="8">
                                  <Select
                                    id={`dimension-${dimension.id}`}
                                    value={
                                      selectedDimensionValues[dimension.id] ||
                                      null
                                    }
                                    onChange={(selectedValue) =>
                                      handleDimensionValueChange(
                                        dimension.id,
                                        selectedValue
                                      )
                                    }
                                    options={
                                      dimension.dimensionValue?.map(
                                        (dv: any) => ({
                                          value: dv.id,
                                          label: dv.displayName,
                                        })
                                      ) || []
                                    }
                                    placeholder={`Select ${dimension.displayName}`}
                                    isSearchable
                                    isDisabled={!editMode}
                                    isClearable
                                  />
                                </Col>
                              </Row>
                              {/* <hr /> */}
                            </div>
                          ));
                        } else {
                          // Show no dimensions message when dimensions exist but have no values
                          return (
                            <div className="no-dimensions-message">
                              <Row className="mb-3">
                                <Col lg="12">
                                  <p className="text-muted text-center">
                                    No dimensions available for this menu type.
                                  </p>
                                </Col>
                              </Row>
                              {/* <hr /> */}
                            </div>
                          );
                        }
                      })()
                    ) : (
                      <div className="no-dimensions-message">
                        <Row className="mb-3">
                          <Col lg="12">
                            <p className="text-muted text-center">
                              No dimensions available for this menu type.
                            </p>
                          </Col>
                        </Row>
                        {/* <hr /> */}
                      </div>
                    )}
                  </>
                )}
              </>
            )}

            {/* isCanSellProduct && (
              <>
                // Portion
                <hr />
                <Row className="mb-3">
                  <Col lg={4}>
                    <Label>Portion Available</Label>
                  </Col>
                  <Col lg={8}>
                    <input
                      type="checkbox"
                      checked={canPortion}
                      className="form-check-input"
                      onChange={handleCheckboxChangeForPortion}
                      value={portionSize}
                      disabled={!editMode}
                    />

                    {canPortion && (
                      <>
                        <hr />
                        <div className="portion-section">
                          <div className="portion-inputs">
                            <Row>
                              <Col md={5} className="mt-1">
                                <ControlledRowSelectPortion
                                  inputName="portionSize"
                                  control={control}
                                  optionsList={portionSizesOptions}
                                  placeholder="Select portion size"
                                  onChange={(option: any) =>
                                    handleSelectPortion(option)
                                  }
                                  isDisabled={!editMode}
                                />
                                <br />
                              </Col>

                              <Col md={5}>
                                <ControlledRowTextFieldForPortion
                                  inputName={"portionPrice"}
                                  inputType={"number"}
                                  placeholder={"Enter portion price"}
                                  control={control}
                                  onChange={(e) => {
                                    const value = Number(e.target.value);
                                    if (value >= 0) {
                                      setPortionPrice(e.target.value);
                                    } else {
                                      setPortionPrice("");
                                      setPortionErrorMessage(
                                        "Portion price cannot be negative."
                                      );
                                    }
                                  }}
                                  isDisabled={!editMode || isPortionPriceDisable}
                                />
                              </Col>

                              <Col md={2}>
                                <ButtonComponent
                                  type="button"
                                  titel="+Add"
                                  onClick={addPortion}
                                  isDisabled={
                                    (portionSizesData?.[0]?.portionSize ===
                                    portionSize
                                      ? false
                                      : isPortionButtonDisabled) || !editMode
                                  }
                                />
                              </Col>
                            </Row>
                          </div>
                          {portionErrorMessage && (
                            <p className="text-danger">{portionErrorMessage}</p>
                          )}
                          <Table>
                            <thead>
                              <tr>
                                <th>Size</th>
                                <th>Price</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {portions.map((portion, index) => (
                                <tr key={index}>
                                  <td>{portion.displayName}</td>
                                  <td>{portion.additionalCost}</td>
                                  <td>
                                    <Button
                                      variant="light"
                                      onClick={() => deletePortion(index)}
                                      disabled={!editMode}
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrash}
                                        title="Delete"
                                        color="#F24E1E"
                                      />
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </>
                    )}
                  </Col>
                </Row>
              </>
            ) */}
          </form>
          <div className="d-flex justify-content-end mt-4 mb-2">
            {updateButtonLoading ? (
              <ButtonComponent
                icon={<FontAwesomeIcon icon={faSpinner} spin />}
                titel="Updating..."
                isDisabled={true}
              />
            ) : (
              <ButtonComponent
                titel="Update"
                onClick={handleSubmit(handleUpdate)}
                isDisabled={!editMode}
              />
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default UpdateItem;
